module.exports = __webpack_public_path__ + "img/nvidia.0aef4db5.svg";